import * as React from 'react';
import { SchoolEvent, SchoolEventTeamDataPlayer } from 'Src/models/event';
import propz from 'propz';
import { PLAYER_POSITIONS } from '../../../../../../../consts/player';

interface Props {
  player: SchoolEventTeamDataPlayer;
  event: SchoolEvent;
}

export function StudentEventTeamPlayerSubOrCaptain(props: Props) {
  const { player, event } = props;

  const playerData = event.players.find(eventPlayer => eventPlayer._id === player.id);
  const sub: boolean = propz.get(playerData, ['sub']);
  const captain: boolean = propz.get(playerData, ['isCaptain']);
  const viceCaptain: boolean = propz.get(playerData, ['isViceCaptain']);
  const playersCaptainOrSubText = [
    captain && PLAYER_POSITIONS.CAPTAIN,
    viceCaptain && PLAYER_POSITIONS.VICE_CAPTAIN,
    sub && PLAYER_POSITIONS.SUB
  ]
    .filter(Boolean)
    .join(' ');

  return playersCaptainOrSubText !== '' ? playersCaptainOrSubText : null;
}
